// import session from '@/utils/session'
export default {
  state: {
    buildingId: 0,
    floorId: 0
  },
  getters: {
    buildingId (state) {
      return state.buildingId
    },
    floorId (state) {
      return state.floorId
    }
  },
  mutations: {
    setBuildingId (state, data) {
      state.buildingId = data
    },
    setFloorId (state, data) {
      state.floorId = data
    }
  },
  actions: {
    setBuildingId ({commit}, value) {
      commit('setBuildingId', value)
    },
    setFloorId ({commit}, value) {
      commit('setFloorId', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-energyManage/store/room.js